import {createFileRoute, Outlet, redirect} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/u/additional-details")({
    beforeLoad: async ({context}) => {
        // #region 727b4576-3be0-4f95-9a4b-bf89ce70fd75
        if (context.profileStatus.isProfileCompleted !== true) {
            console.groupCollapsed("User does not have a completed profile, redirecting to profile completion");
            console.log("profileStatus", context.profileStatus);
            console.groupEnd();

            // TODO: Get this from heimdallConfiguration or something
            const redirectTo = "/set-profile";

            throw redirect({
                to: redirectTo,
            });
        }
        // #endregion
    },
    component: Outlet,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
